import React, { useState } from 'react';
import { useTabs, TabBar } from './TabManager';
import { useVbMenu, tabButtonOn } from '../utils/vbPerms';
import WarningDialog from '../components/WarningDialog';
import ContractList from './Contract/ContractList';   // قراردادها
import ContractorList from './Contract/ContractorList'; // پیمانکاران
import ContractTypeList from './Contract/ContractTypeList'; // انواع قراردادها
import ContractorStatementList from './Contract/ContractorStatementList'; // انواع صورت وضعیت‌ها
import ExecutiveDomainList from './Contract/ExecutiveDomainList'; // حوزه اجرایی قراردادها
import TaminBranchList from './Contract/TaminBranchList'; // شعب تامین اجتماعی
import ControlContractorRequestList from './Contract/ControlContractorRequestList'; // رسیدگی نهایی
import ContractorRequestList from './Contract/ContractorRequestList'; // صورت وضعیت قراردادها
import ContractHistoryReport from './Contract/ContractHistoryReport'; // شناسنامه قراردادها
import TarPriceList from './Contract/TarPriceList'; // بهای قیر

/* دکمه‌های منوی قراردادها — key همان کلید مجوز دکمه است.
   ترتیب: ابتدا ستون تعاریف (سمت راست منو) سپس ستون عملیات (سمت چپ). */
const CONTRACT_BUTTONS = [
  /* ── ستون تعاریف (سمت راست منو) ── */
  { key: 'btnContract',          label: 'قراردادها',              icon: '📋', bg: 'linear-gradient(135deg,#4a148c,#6a1b9a)', page: 'contract' },
  { key: 'btnContractor',        label: 'پیمانکاران',             icon: '👷', bg: 'linear-gradient(135deg,#311b92,#4527a0)', page: 'contractor' },
  { key: 'btnContractType',      label: 'انواع قراردادها',        icon: '🗂️', bg: 'linear-gradient(135deg,#0d47a1,#1565c0)', page: 'contract_type' },
  { key: 'btnContractorStatement', label: 'انواع صورت وضعیت ها',  icon: '🏷️', bg: 'linear-gradient(135deg,#006064,#00838f)', page: 'statement_type' },
  { key: 'btnExecutiveDomain',   label: 'حوزه اجرایی قراردادها',  icon: '🌐', bg: 'linear-gradient(135deg,#33691e,#558b2f)', page: 'executive_domain' },
  { key: 'btnTaminBranch1',      label: 'شعب تامین اجتماعی',      icon: '🏦', bg: 'linear-gradient(135deg,#880e4f,#ad1457)', page: 'tamin_branch' },

  /* ── ستون عملیات (سمت چپ منو) ── */
  { key: 'btnControlContractorRequest',       label: 'رسیدگی نهایی',           icon: '✅', bg: 'linear-gradient(135deg,#1b5e20,#2e7d32)', page: 'final_review' },
  { key: 'btnControlContractorRequestDetail', label: 'درخواستهای ارجاع شده',   icon: '📨', bg: 'linear-gradient(135deg,#e65100,#f57c00)', page: 'referred_requests' },
  { key: 'btnContractorRequest',              label: 'صورت وضعیت قراردادها',   icon: '🧾', bg: 'linear-gradient(135deg,#bf360c,#d84315)', page: 'contractor_statement' },
  { key: 'btnContractHistory1',               label: 'شناسنامه قراردادها',     icon: '📇', bg: 'linear-gradient(135deg,#004d40,#00695c)', page: 'contract_history' },
  { key: 'btnTarPrice',                       label: 'بهای قیر',               icon: '🛢️', bg: 'linear-gradient(135deg,#37474f,#455a64)', page: 'tar_price' },
];

/* زیرصفحه‌های ساخته‌شده — با تکمیل هر بخش اینجا اضافه می‌شود */
const PAGE_COMPONENTS = {
  contract:      ContractList,     // قراردادها
  contractor:    ContractorList,   // پیمانکاران
  contract_type:  ContractTypeList,        // انواع قراردادها
  statement_type:   ContractorStatementList, // انواع صورت وضعیت‌ها
  executive_domain: ExecutiveDomainList,      // حوزه اجرایی قراردادها
  tamin_branch:     TaminBranchList,          // شعب تامین اجتماعی
  final_review:     ControlContractorRequestList, // رسیدگی نهایی
  contractor_statement: ContractorRequestList,  // صورت وضعیت قراردادها
  contract_history: ContractHistoryReport,      // شناسنامه قراردادها
  tar_price:        TarPriceList,               // بهای قیر
};

/* دکمه‌هایی که پیش از باز شدن هشدار نشان می‌دهند.
   ورود مستقیم به فرم صورت وضعیت یعنی بدون قرارداد، و در آن حالت هر شش ستون
   کسورات صفر نمایش داده می‌شود — برای همین هشدار می‌دهد. */
const OPEN_WARNINGS = {
  btnContractorRequest: {
    title: 'هشدار',
    lines: [
      'توجه کنید که اگر از این گزینه به فرم صورت وضعیت وارد شوید، کسورات صورت وضعیت نشان داده نمیشود',
      'پیشنهاد میشود که ابتدا فرم قراردادها را باز کرده و سپس با انتخاب قرارداد مورد نظر، وارد فرم صورت وضعیت شوید',
    ],
    cancel:  'لغو',
    confirm: 'فرم صورت وضعیت بدون نمایش کسورات باز شود',
  },
};

export default function Contract({ user, onBack }) {
  const { openTab, goHome } = useTabs();
  const [warn, setWarn] = useState(null);   // دکمه‌ای که منتظر تایید هشدار است

  const doOpen = (btn) => {
    const Comp = PAGE_COMPONENTS[btn.page];
    if (!Comp) { alert(`صفحه "${btn.label}" در حال توسعه است`); return; }
    openTab(`contract:${btn.page}`, btn.label, btn.icon,
      () => <Comp user={user} onBack={goHome} />);
  };

  const openSubPage = (btn) => {
    const w = OPEN_WARNINGS[btn.key];
    if (w) { setWarn({ btn, ...w }); return; }   // اول هشدار
    doOpen(btn);
  };

  // دکمه‌های تب — دکمهٔ بی‌مجوز غیرفعال (خاکستری) دیده می‌شود
  const menu = useVbMenu();
  const allowedBtns = CONTRACT_BUTTONS.map(btn => ({
    ...btn, _on: tabButtonOn(menu, 'TBCONTRACT', btn.vb || btn.key),
  }));
  const enabledCount = allowedBtns.filter(b => b._on).length;

  const gridResponsiveCSS = `@media(max-width:640px){.arjan-acc-grid{grid-template-columns:repeat(2,1fr)!important;gap:16px!important;max-width:360px;margin:0 auto;padding:0 12px;}}`;

  return (
    <><style>{gridResponsiveCSS}</style>
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../assets/images/arjan.png')} alt="ارجان" style={{width:'36px',height:'36px',borderRadius:'8px'}}/></div>
          <div><div style={s.hTitle}>سامانه ارجان</div><div style={s.hSub}>بخش قراردادها</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>
      <main style={s.main}>
        <div style={s.hero}><div style={s.heroIcon}>📋</div><div><h2 style={s.heroTitle}>بخش قراردادها</h2><p style={s.heroSub}>{enabledCount} مورد در دسترس شما</p></div></div>
        {enabledCount > 0 || allowedBtns.length > 0 ? (
          <div className="arjan-acc-grid" style={s.grid}>
            {allowedBtns.map(btn => (
              <div key={btn.key} style={s.btnWrap}>
                <button disabled={!btn._on} style={{...s.btn,background:btn.bg,...(btn._on?{}:DISABLED)}} onClick={()=>btn._on&&openSubPage(btn)}
                  onMouseEnter={e=>{if(!btn._on)return;e.currentTarget.style.transform='translateY(-8px) scale(1.05)';e.currentTarget.style.boxShadow='0 16px 40px rgba(0,0,0,0.35)';}}
                  onMouseLeave={e=>{e.currentTarget.style.transform='translateY(0) scale(1)';e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.2)';}}>
                  <span style={s.btnIcon}>{btn.icon}</span>
                </button>
                <div style={s.btnLabel}>{btn.label}</div>
              </div>
            ))}
          </div>
        ) : (<div style={s.noAccess}><div style={{fontSize:'56px',marginBottom:'16px'}}>🔒</div><div style={{fontSize:'16px',color:'#666'}}>دسترسی به این بخش تعریف نشده است</div></div>)}
      </main>

      {/* هشدار پیش از باز شدن فرم */}
      {warn && (
        <WarningDialog
          title={warn.title}
          lines={warn.lines}
          confirmLabel={warn.confirm}
          cancelLabel={warn.cancel}
          onConfirm={() => { const b = warn.btn; setWarn(null); doOpen(b); }}
          onCancel={() => setWarn(null)}
        />
      )}
    </div></>
  );
}


/* استایل‌ها — یک‌دست با بخش بودجه */
const s = {
  page:{minHeight:'100vh',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'12px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',position:'sticky',top:0,zIndex:100},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'16px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'32px 24px',maxWidth:'1100px',margin:'0 auto'},
  hero:{display:'flex',alignItems:'center',gap:'16px',marginBottom:'32px'},
  heroIcon:{fontSize:'40px'},
  heroTitle:{fontSize:'22px',fontWeight:'800',color:'#1a2f50',margin:0},
  heroSub:{fontSize:'13px',color:'#888',margin:'4px 0 0'},
  grid:{display:'grid',gridTemplateColumns:'repeat(4,160px)',gap:'24px',justifyContent:'center'},
  btnWrap:{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px'},
  btn:{width:'100%',aspectRatio:'1',border:'none',borderRadius:'20px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 8px 24px rgba(0,0,0,0.2)',transition:'all .25s'},
  btnIcon:{fontSize:'36px'},
  btnLabel:{fontSize:'13px',fontWeight:'700',color:'#333',textAlign:'center'},
  noAccess:{textAlign:'center',padding:'60px 20px'},
};

// دکمهٔ تبِ بی‌مجوز: دیده می‌شود ولی کار نمی‌کند
const DISABLED = { filter: 'grayscale(1)', opacity: 0.45, cursor: 'not-allowed', boxShadow: 'none' };
